export default {
  OPPORTUNITIES: 'Opportunities',
  OPPORTUNITIES_ACTUAL_LABEL: 'Actual',
  OPPORTUNITIES_ACTUAL_VALUE_LABEL: 'Actual Value',
  OPPORTUNITIES_ADD_AN_OPPORTUNITY: 'Add an opportunity',
  OPPORTUNITIES_ADD_OPPORTUNITY: 'Add Opportunity',
  OPPORTUNITIES_ARCHIVE: 'Archive',
  OPPORTUNITIES_ARCHIVE_FAILURE: 'Error, archiving opportunity failed',
  OPPORTUNITIES_ARCHIVE_SUCCESS: 'Opportunity successfully archived',
  OPPORTUNITIES_ASK_AMOUNT_LABEL: 'Ask Amount',
  OPPORTUNITIES_ASK_LABEL: 'Ask',
  OPPORTUNITIES_CAMPAIGN_LABEL: 'Campaign',
  OPPORTUNITIES_CONFIDENCE_LABEL: 'Confidence',
  OPPORTUNITIES_CONFIDENCE_LEVEL_LABEL: 'Confidence Level',
  OPPORTUNITIES_CONFIDENCE_LEVEL_LOW: 'Low',
  OPPORTUNITIES_CONFIDENCE_LEVEL_MEDIUM: 'Medium',
  OPPORTUNITIES_CONFIDENCE_LEVEL_HIGH: 'High',
  OPPORTUNITIES_CONSTITUENT_LABEL: 'Constituent',
  OPPORTUNITIES_CREATE_FAILURE: 'Error, opportunity creation failed',
  OPPORTUNITIES_CREATE_SUCCESS: 'Opportunity successfully created',
  OPPORTUNITIES_DAYS_ACTIVE_LABEL: 'Days Active',
  OPPORTUNITIES_DELETE_OPPORTUNITY: 'Delete Opportunity',
  OPPORTUNITIES_DELETE_CONFIRM_MSG:
    'Are you sure you want to delete this opportunity from the organization?',
  OPPORTUNITIES_DELETE_FAILURE: 'Error, opportunity deletion failed',
  OPPORTUNITIES_DELETE_SUCCESS: 'Opportunity successfully deleted',
  OPPORTUNITIES_DETAILS_HEADER: 'Opportunity Details',
  OPPORTUNITIES_EDIT_OPPORTUNITY: 'Edit Opportunity',
  OPPORTUNITIES_EDIT_FAILURE: 'Error, updating opportunity failed',
  OPPORTUNITIES_EDIT_SUCCESS: 'Opportunity successfully updated',
  OPPORTUNITIES_EMPTY_LIST: 'No opportunities to display.',
  OPPORTUNITIES_EXPECTED_CLOSED_DATE_LABEL: 'Expected Close Date',
  OPPORTUNITIES_EXPECTED_AMOUNT_LABEL: 'Expected',
  OPPORTUNITIES_EXPECTED_CLOSE_DATE_LABEL: 'Expected Close Date',
  OPPORTUNITIES_EXPECTED_LABEL: 'Expected',
  OPPORTUNITIES_FILTERS: 'Opportunity filters',
  OPPORTUNITIES_INCLUDE_ARCHIVED: 'Include Archived',
  OPPORTUNITIES_GROUP_BY: 'Group By',
  OPPORTUNITIES_GROUP_BY_LABEL: 'Group Opportunities By',
  OPPORTUNITIES_GROUP_BY_CONFIDENCE_LEVEL: 'Confidence Level',
  OPPORTUNITIES_GROUP_BY_NONE: 'None',
  OPPORTUNITIES_GROUP_BY_STAGE: 'Stage',
  OPPORTUNITIES_GROUP_BY_TOTAL_ASK: 'Total Ask:',
  OPPORTUNITIES_GROUP_BY_TOTAL_EXPECTED: 'Total Expected:',
  OPPORTUNITIES_GROUP_BY_TOTAL_PROJECTED: 'Total Projected:',
  OPPORTUNITIES_GROUP_BY_TOTAL_WON: 'Total Won:',
  OPPORTUNITIES_LINK_CONTRIBUTION: 'Link Contribution',
  OPPORTUNITIES_LINK_OPPORTUNITY: 'Link Opportunity to Contribution',
  OPPORTUNITIES_NO_ARCHIVED: 'There are no archived opportunities to display.',
  OPPORTUNITIES_NO_OWNER: 'No Owner',
  OPPORTUNITIES_NOTES_LABEL: 'Notes',
  OPPORTUNITIES_OPPORTUNITY_OWNER: 'Opportunity Owner',
  OPPORTUNITIES_OWNER_LABEL: 'Owner',
  OPPORTUNITIES_PROJECTED_LABEL: 'Projected',
  OPPORTUNITIES_PROJECTED_ACTUAL_LABEL: 'Projected/Actual',
  OPPORTUNITIES_PROJECTED_ACTUAL_TOOLTIP: 'Value displayed is based upon stage',
  OPPORTUNITIES_RECEIVED_LABEL: 'Received',
  OPPORTUNITIES_STAGE_CULTIVATING: 'Cultivating',
  OPPORTUNITIES_STAGE_LABEL: 'Stage',
  OPPORTUNITIES_STAGE_LOST: 'Lost',
  OPPORTUNITIES_STAGE_PROSPECTING: 'Prospecting',
  OPPORTUNITIES_STAGE_REQUESTING: 'Requesting',
  OPPORTUNITIES_STAGE_WON: 'Won',
  OPPORTUNITIES_STATUS: 'Status ({activeFilterCount})',
  OPPORTUNITIES_STATUS_ACTIVE: 'Active',
  OPPORTUNITIES_STATUS_ARCHIVED: 'Archived',
  OPPORTUNITIES_SUMMARY_LOSS_RATE: 'Loss Rate',
  OPPORTUNITIES_SUMMARY_TOTAL_ASK: 'Total Ask',
  OPPORTUNITIES_SUMMARY_TOTAL_EXPECTED: 'Total Expected',
  OPPORTUNITIES_SUMMARY_TOTAL_LOST: 'Total Lost',
  OPPORTUNITIES_SUMMARY_TOTAL_PROJECTED: 'Total Projected',
  OPPORTUNITIES_SUMMARY_TOTAL_WON: 'Total Won',
  OPPORTUNITIES_SUMMARY_WIN_RATE: 'Win Rate',
  OPPORTUNITIES_TABLE_HEADER: 'All Opportunities ({count})',
  OPPORTUNITIES_TOTAL_VALUES_BY_STAGE: 'Total Values by Stage',
  OPPORTUNITIES_UNARCHIVE: 'Unarchive',
  OPPORTUNITIES_UNARCHIVE_FAILURE: 'Error, unarchiving opportunity failed',
  OPPORTUNITIES_UNARCHIVE_SUCCESS: 'Opportunity successfully unarchived',
  OPPORTUNITIES_UPDATE_FAILURE: 'Error, opportunity update failed',
  OPPORTUNITIES_VIEW: 'View opportunities',
  OPPORTUNITIES_COMPARISON_REPORT: 'Opportunities Values Comparison',
  OPPORTUNITIES_PICK_3: 'Select up to 3 amounts',
  OPPORTUNITIES_COUNT:
    '{count, plural, =1 {1 Opportunity} other {# Opportunities}}',
  OPPORTUNITIES_CLOSED_WON: 'Closed Won',
  OPPORTUNITIES_CLOSED_LOST: 'Closed Lost',
  OPPORTUNITIES_CLOSED_OPPORTUNITIES: 'Closed Opportunities',
  OPPORTUNITIES_CLOSED_BY_OWNER: 'Closed Opportunities by Owner',
  OPPORTUNITY: 'Opportunity',
};
